import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'

import Icon from './Icon'

const Logo = ({ onTopOfDarkSection, icon = 'logo' }) => {
  const classes = classnames(
    {
      'logo--on-dark-bg': onTopOfDarkSection
    },
    'logo icon'
  )
  return <Icon icon={icon} className={classes} />
}

Logo.propTypes = {
  onTopOfDarkSection: PropTypes.bool
}

export default Logo



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/Logo.js